import { fileKeyFacet } from '../Schema/Facets';
import { getParameterStore } from '../store/ParametersStore';
import { AttachmentModel, lazyGetAttachment, TypeOfAttachment } from 'owa-attachment-model-store';
import { openInNewTab } from 'owa-attachment-user-operations';
import LinkAttachment from 'owa-service/lib/contract/LinkAttachment';
import { PreviewPaneSelectionSource, SxSCustomization, sxsStore } from 'owa-sxs-store';
import { lazySetRightPaneDisplayAndUpdateSize } from 'owa-sxsdata';
import * as React from 'react';
import {
    connectToItemCache,
    IItemCache,
    IItemOpenUrlActionProps,
    IActionProps,
    Action,
    IDefaultClickActionHandler,
    Facet,
    IDefaultClickActionHandlerProps,
    defaultClickActionControl,
    openDefaultClickActionHandler,
} from '@ms/items-view';
import {
    lazyPreviewAttachmentInSxS,
    SxSReadingPaneInitializeMethod,
    SxSReadingPaneStrategy,
} from 'owa-attachment-preview-sxs-actions';
import {
    createAttachmentFullViewState,
    initializeAttachmentFullViewState,
} from 'owa-attachment-full-data';

export const ItemOpenSxSAction = connectToItemCache(
    (
        itemCache: IItemCache,
        props: IItemOpenUrlActionProps
    ): Pick<IActionProps, 'isAvailable' | 'engagement' | 'onExecute'> => {
        const { itemKey } = props;

        const { id, conversationId, conversationSubject } = itemCache.demandItemFacet(
            fileKeyFacet,
            itemKey
        );

        const parameterStore = getParameterStore();

        return {
            isAvailable: !!id,
            onExecute: id
                ? async () => {
                      const attachmentId = {
                          Id: id,
                          mailboxInfo: parameterStore.mailboxInfo,
                      };
                      const attachmentViewState = createAttachmentFullViewState(
                          attachmentId,
                          true, // isReadOnly
                          true, // uploadCompleted
                          false // TODO figure out how to set this right think this is attachment vs cloudy,
                      );
                      const getAttachment = await lazyGetAttachment.import();
                      const attachment: AttachmentModel = getAttachment(attachmentId);

                      // Open link attachments in a new tab since preview not supported
                      if (attachment.type === TypeOfAttachment.Link) {
                          openInNewTab((attachment.model as LinkAttachment).WebUrl);
                          return;
                      }

                      initializeAttachmentFullViewState(
                          attachmentViewState,
                          attachment,
                          false /* treatLinksAsAttachments */,
                          attachmentViewState.strategy.supportedMenuActions
                      );

                      let readingPaneStrategy: SxSReadingPaneStrategy = {
                          method: SxSReadingPaneInitializeMethod.AlwaysHidden,
                      };

                      if (conversationId) {
                          readingPaneStrategy = {
                              method: SxSReadingPaneInitializeMethod.LoadConversationReadingPane,
                              conversationId: {
                                  Id: conversationId,
                                  mailboxInfo: parameterStore.mailboxInfo,
                              },
                              conversationSubject: conversationSubject,
                              conversationCategories: [],
                          };
                      }

                      lazySetRightPaneDisplayAndUpdateSize
                          .import()
                          .then(setRightPaneDisplayAndUpdateSize => {
                              setRightPaneDisplayAndUpdateSize(sxsStore.viewState, 1);
                          });

                      lazyPreviewAttachmentInSxS.importAndExecute(
                          attachmentViewState,
                          attachmentId,
                          false,
                          false,
                          PreviewPaneSelectionSource.ConsumerGroupFilesHub,
                          null, // createImageGallery
                          readingPaneStrategy,
                          null, //TODO figure out if I need this (instrumentationContext)
                          SxSCustomization.GroupFilesHub
                      );
                  }
                : undefined,
            engagement: {
                name: 'OpenSxS',
                isIntentional: true,
                scenario: parameterStore.scenarioName,
            },
        };
    }
)(Action);

export const openSxSDefaultClickActionHandler: IDefaultClickActionHandler = {
    key: new Facet('openSxSDefaultClickActionHandler').id,
    evaluate: (itemCache: IItemCache, props: IDefaultClickActionHandlerProps) => {
        const { itemKey } = props;

        return {
            action: <ItemOpenSxSAction itemKey={itemKey} />,
        };
    },
};

export function defaultClickActionControlHandler(
    itemCache: IItemCache,
    props: typeof defaultClickActionControl.inputType
): typeof defaultClickActionControl.returnType {
    const { handlers } = props;

    return {
        handlers: [
            openDefaultClickActionHandler,
            openSxSDefaultClickActionHandler,
            ...(handlers || []),
        ],
    };
}
